<script>
import constant from './Constant'
import store from '../../vuex'
import axios from 'axios'
import variable from './Variable'
import storage from './LocalStorage'

let utils = {
  data () {
    return {
      constant: constant,
      store: store,
      axios: axios,
      variable: variable,
      showMap: false,
      markers: [],
      displayedSpots: []
    }
  },
  methods: {
    headers () {
      return {
        'Authorization': 'Basic ' + this.getItem('access_token')
      }
    },
    getImgPath (src) {
      return src !== null && src !== undefined ? 'https://s3-ap-northeast-1.amazonaws.com/thegate/' + src : ''
    },
    completed (statusText) {
      if (statusText === 'ok') {
        return true
      }
      return false
    },
    showModal (type, callback, isPush = false) {
      document.activeElement.blur()
      let speed = 0
      if (this.isIOS()) {
        if (store.getters['spMenu/getScrollY'] === 0) {
          store.dispatch('spMenu/setScrollY', parseInt(window.scrollY))
        }
        document.getElementsByClassName('l-global')[0].style.top = '-' + store.getters['spMenu/getScrollY'] + 'px'
        speed = 200
      }
      setTimeout(() => {
        if ($('.modal.active').length > 0) {
          // $('.modal.active').fadeOut(300, () => {
          document.getElementsByClassName('modal active')[0].removeAttribute('style')
          if (!isPush) {
            store.dispatch('modal/setModal', '')
            store.dispatch('modal/setModal', type)
          } else {
            const curModals = store.getters['modal/getModal'] || ''
            store.dispatch('modal/setModal', curModals.split(',').concat(type).join(','))
          }
          // })
        } else if ($('.modal.fade-in').length > 0) {
          $('.modal.fade-in').fadeOut(300, () => {
            document.getElementsByClassName('modal fade-in')[0].removeAttribute('style')
            store.dispatch('modal/setModal', '')
            store.dispatch('modal/setModal', type)
          })
        } else {
          store.dispatch('modal/setModal', type)
        }
      }, speed)
      if (this.isFirefox()) {
        let count = 0
        setInterval(() => {
          count++
          if (count <= 20) {
            document.getElementsByClassName('modal active')[0].style.height = document.getElementsByClassName('modal active')[0].firstChild.clientHeight + 'px'
            document.getElementsByClassName('modal fade-in')[0].style.height = document.getElementsByClassName('modal fade-in')[0].firstChild.clientHeight + 'px'
          }
        }, 100)
      }
      setTimeout(() => {
        !!callback && callback()
      }, 200)
    },
    showSmallMenu (menu) {
      document.activeElement.blur()
    },
    closeElement (isPop = false) {
      store.dispatch('spMenu/setActiveMenu', false)
      // store.dispatch('smallMenu/setMenu', '')
      if (!isPop) {
        $('.overlay-all').fadeOut(300, () => {
          document.getElementsByClassName('overlay-all')[0].removeAttribute('style')
        })

        $('.overlay-all-transparent').fadeOut(300, () => {
          document.getElementsByClassName('overlay-all-transparent')[0].removeAttribute('style')
        })
      }

      let jquerySelector = ''
      let selector = ''
      if ($('.modal.active').length > 0) {
        // TODO activeとfade-inの対応をするまで
        jquerySelector = $('.modal.active')
        selector = document.getElementsByClassName('modal active')
      } else if ($('.modal.fade-in').length > 0) {
        jquerySelector = $('.modal.fade-in')
        selector = document.getElementsByClassName('modal fade-in')
      } else if ($('.l-manager-modal-main.fade-in').length > 0) {
        jquerySelector = $('.l-manager-modal-main.fade-in')
        selector = document.getElementsByClassName('l-manager-modal-main fade-in')
      } else if ($('.l-admin-modal-main.fade-in').length > 0) {
        jquerySelector = $('.l-admin-modal-main.fade-in')
        selector = document.getElementsByClassName('l-admin-modal-main fade-in')
      }

      if (jquerySelector.length > 0) {
        if (!isPop) {
          jquerySelector.fadeOut(300, () => {
            Array.from(selector).forEach(_ => _.removeAttribute('style'))
            store.dispatch('modal/setModal', '')
            store.dispatch('modal/setKey1', null)
            store.dispatch('modal/setKey2', null)
            store.dispatch('modal/setHead1', '')
            store.dispatch('modal/setMessage1', '')
            store.dispatch('modal/setMessage2', '')
            store.dispatch('modal/setMessage3', '')
            store.dispatch('modal/setMessage4', '')
          })
        } else {
          selector[selector.length - 1].removeAttribute('style')
          const modals = store.getters['modal/getModal'].split(',')
          modals.pop()
          store.dispatch('modal/setModal', modals.join(','))
          store.dispatch('modal/setKey1', null)
          store.dispatch('modal/setKey2', null)
          store.dispatch('modal/setHead1', '')
          store.dispatch('modal/setMessage1', '')
          store.dispatch('modal/setMessage2', '')
          store.dispatch('modal/setMessage3', '')
          store.dispatch('modal/setMessage4', '')
        }
      }

      let jquerySearchSelector = ''
      let searchSelector = ''
      if ($('.search-modal.active').length > 0) {
        // TODO activeとfade-inの対応をするまで
        jquerySearchSelector = $('.search-modal.active')
        searchSelector = document.getElementsByClassName('search-modal active')
      } else if ($('.search-modal.fade-in').length > 0) {
        jquerySearchSelector = $('.search-modal.fade-in')
        searchSelector = document.getElementsByClassName('search-modal fade-in')
      }

      if (jquerySearchSelector.length > 0) {
        jquerySearchSelector.fadeOut(300, () => {
          searchSelector[0].removeAttribute('style')
          if (searchSelector[1] !== undefined) {
            searchSelector[1].removeAttribute('style')
          }
          if (searchSelector[2] !== undefined) {
            searchSelector[2].removeAttribute('style')
          }
          store.dispatch('modal/setModal', '')
          store.dispatch('modal/setKey1', null)
          store.dispatch('modal/setKey2', null)
        })
      }

      if (this.isIOS()) {
        setTimeout(() => {
          window.scroll(0, store.getters['spMenu/getScrollY'])
          store.dispatch('spMenu/setScrollY', 0)
        }, 400)
      }
    },
    isJson (arg) {
      arg = (typeof arg === 'function') ? arg() : arg
      if (typeof arg !== 'string') {
        return false
      }
      try {
        arg = JSON.parse(arg)
        return true
      } catch (e) {
        return false
      }
    },
    isIOS () {
      let ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('iphone') > 0 || ua.indexOf('ipad') > 0 || ua.indexOf('ipod') > 0
    },
    isFirefox () {
      return navigator.userAgent.toLowerCase().indexOf('firefox') > 0
    },
    getAbsolutePosition (elm) {
      let {left, top} = elm.getBoundingClientRect()
      let {left: bLeft, top: bTop} = document.body.getBoundingClientRect()
      return {
        left: left - bLeft,
        top: top - bTop
      }
    },
    callScript (src, handler) {
      let base = document.getElementsByTagName('script')[0]
      let obj = document.createElement('script')
      obj.async = true
      obj.src = src
      if (obj.addEventListener) {
        obj.onload = () => {
          handler()
        }
      } else {
        obj.onreadystatechange = () => {
          if (obj.readyState === 'loaded' || obj.readyState === 'complete') {
            obj.onreadystatechange = null
            handler()
          }
        }
      }
      base.parentNode.insertBefore(obj, base)
    },
    getUserApi (url, param) {
      return new Promise((resolve, reject) => {
        console.log('get user api', process.env.API_BASE_URL + url)
        axios.get(process.env.API_BASE_URL + url, {
          params: param,
          headers: this.headers()
        }).then(res => {
          if (this.completed(res.data.result)) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        }).catch(error => {
          console.log(error)
          this.systemError()
          throw error
        })
      })
    },
    postUserApi (url, body) {
      var config = {
        headers: this.headers()
      }
      return new Promise((resolve, reject) => {
        axios.post(process.env.API_BASE_URL + url, body, config)
          .then(res => {
            if (this.completed(res.data.result)) {
              resolve(res.data)
            } else {
              reject(res.data)
            }
          })
          .catch(error => {
            console.error(error)
            this.systemError()
            reject(error)
          })
      })
    },
    systemError () {
      // alert('システムエラーが発生しました。')
    },
    setMenuSelected () {
      this.store.dispatch('menu/setZoom', true)

      setTimeout(() => {
        this.store.dispatch('menu/setSelected', !this.store.getters['menu/getSelected'])
      }, 150)

      setTimeout(() => {
        this.store.dispatch('menu/setZoom', false)
      }, 600)
    },
    getMarkerCoordinates () {
      // for (let i = 0; i < this.markers.length; i++) {
      //   this.markers[i].setMap(null)
      // }
      // this.markers.length = 0
      // let imgs = document.querySelectorAll('img[src^="//geouser.canmee.jp"], img[src^="//geo-mark-user-local.com"], img[src^="//user.geomarks.co"], img[src="/static/icon_marker.png"], img[src="/static/icon_went_marker.png"], img[src="/static/icon_want_marker.png"]')
      // if (imgs.length > 0) {
      //   imgs.forEach(img => {
      //     if (!img.classList.contains('detail-image')) {
      //       img.remove()
      //     }
      //   })
      // }
      let zoom = this.store.getters['coordinate/getZoom']
      let params = {page: 1, lat: this.store.getters['centerLatLng/getLat'], lon: this.store.getters['centerLatLng/getLng'], zoom: zoom}
      if (this.store.getters['search/getSearchWord'] !== '') {
        let searchWordList = []
        let searchWordSplit = this.store.getters['search/getSearchWord'].split(/\s+/)
        searchWordSplit.forEach((word) => {
          searchWordList.push(word)
        })
        params['tags'] = searchWordList
      }

      if (this.store.getters['search/getMonths'] !== '') {
        params['months'] = this.store.getters['search/getMonths']
      }
      this.getUserApi('articles/getNearArticles', params).then(async (data) => {
        let spots = data.data
        if (this.isLoggedIn()) {
          this.getUserApi('favorites/mine').then(res => {
            let favorites = res.data
            spots = this.filterSpots(spots, favorites)
            this.store.dispatch('coordinate/setCoordinate', spots)
            this.showMap = true
            const ids = (res.data && res.data.map(f => parseInt(f.article_id))) || []
            this.store.dispatch('favorite/setFavorite', ids)
          }).catch(e => {
            if (e.code === 401) {
              this.logout()
            }
          })
        } else {
          spots = this.filterSpots(spots, [])
          this.store.dispatch('coordinate/setCoordinate', spots)
          this.showMap = true
        }
        setTimeout(() => {
          this.showDetail = true
        }, 500)
      }).catch(error => {
        console.error(error)
        this.systemError()
      })
    },
    filterSpots (all, favorites) {
      const LIMIT = 150
      let spots = []

      all.sort((s1, s2) => {
        return parseInt(s1.marker_size || 50) <= parseInt(s2.marker_size || 50) ? 1 : -1
      })
      all.forEach(_ => {
        if (favorites.find(f => f.article_id === _.id) && !spots.find(s => s.id === _.id)) {
          spots.unshift(_)
        }
        if (!spots.find(s => s.id === _.id)) {
          spots.push(_)
        }
      })
      return spots.splice(0, LIMIT)
    },
    isWant () {
      return this.store.getters['want/getWant'].some(want => want === this.store.getters['detail/getId'])
    },
    isWent () {
      return this.store.getters['went/getWent'].some(went => went === this.store.getters['detail/getId'])
    },
    isFavorite () {
      return this.store.getters['favorite/getFavorite'].some(favorite => favorite === this.store.getters['detail/getId'])
    },
    addWant () {
      if (!this.isWant()) {
        let wants = this.store.getters['want/getWant']
        wants.push(this.store.getters['detail/getId'])
        this.store.dispatch('want/setWant', wants)
      }
    },
    addWent () {
      if (!this.isWent()) {
        let wents = this.store.getters['went/getWent']
        wents.push(this.store.getters['detail/getId'])
        this.store.dispatch('went/setWent', wents)
      }
    },
    addFavorite () {
      if (!this.isFavorite()) {
        let favorites = this.store.getters['favorite/getFavorite']
        favorites.push(this.store.getters['detail/getId'])
        this.store.dispatch('favorite/setFavorite', favorites)
      }
    },
    removeWant () {
      if (this.isWant()) {
        let wants = this.store.getters['want/getWant']
        wants.splice(wants.indexOf(this.store.getters['detail/getId']), 1)
        this.store.dispatch('want/setWant', wants)
      }
    },
    removeWent () {
      if (this.isWent()) {
        let wents = this.store.getters['went/getWent']
        wents.splice(wents.indexOf(this.store.getters['detail/getId']), 1)
        this.store.dispatch('went/setWent', wents)
      }
    },
    removeFavorite () {
      if (this.isFavorite()) {
        let favorites = this.store.getters['favorite/getFavorite']
        favorites.splice(favorites.indexOf(this.store.getters['detail/getId']), 1)
        this.store.dispatch('favorite/setFavorite', favorites)
      }
    },
    resizeImage (file) {
      return new Promise(resolve => {
        // Resize Upload Image
        var reader = new FileReader()

        reader.onload = function (e) {
          var image = new Image()
          image.onload = function () {
            var canvas = document.createElement('canvas')
            var context = canvas.getContext('2d')
            context.drawImage(image, 0, 0)

            var MAX_SIZE = 1080
            var width = image.width
            var height = image.height

            if (width > height) {
              if (width > MAX_SIZE) {
                height *= MAX_SIZE / width
                width = MAX_SIZE
              }
            } else {
              if (height > MAX_SIZE) {
                width *= MAX_SIZE / height
                height = MAX_SIZE
              }
            }
            canvas.width = width
            canvas.height = height

            context.drawImage(image, 0, 0, width, height)
            var url = canvas.toDataURL('image/jpeg', 0.8)
            resolve(url)
          }
          image.src = e.target.result
        }
        reader.readAsDataURL(file)
      })
    },
    dataURItoFile (dataUri) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataUri.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataUri.split(',')[1])
      } else {
        byteString = unescape(dataUri.split(',')[1])
      }

      // separate out the mime component
      var mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      var blob = new Blob([ia], {type: mimeString})
      return new File([blob], 'uploaded_file.jpg', {type: 'image/jpeg', lastModified: Date.now()})
    }
  },
  computed: {
    isProduction: () => {
      return location.host === ''
    }
  },
  mixins: [storage]
}

export default utils
</script>



// WEBPACK FOOTER //
// src/utils/vue/Utils.vue